module.exports = {"130273001":"街道","130273101":"老庄子镇","130273401":"庆北","130273402":"三女河"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130273.json
// module id = 180
// module chunks = 0